export default {
  'components.DialogSelecFolder.348250-0': '请输入关键词搜索类别',
  'components.DialogSelecFolder.348250-1': '查询',
  'components.DialogSelecFolder.348250-2': '新建分类',
  'components.DialogSelecFolder.348250-3': '选择类别',
  'components.DialogSelecFolder.348250-4': '接口错误',
  'components.DialogSelecFolder.348250-5': '请输入类别名称（三位数字 + 中文/字母/数字/-/_）',
  'components.DialogSelecFolder.348250-5-1': '请输入类别名称',
  'components.DialogSelecFolder.348250-6': '新建 {0} 类别',
  'components.DialogSelecFolder.348250-7': '确定',
  'components.DialogSelecFolder.348250-8': '取消',
  'components.DialogSelecFolder.348250-9': '命名不符合规范',
  'components.DialogSelecFolder.348250-10': '请填写分类名称',
  'components.DialogSelecFolder.348250-11': '操作失败',
  'components.DialogSelecFolder.348250-13': '【{0}】下 {1} 分类新建成功',
  'components.DialogSelecFolder.348250-14': '重命名',
  'components.IppInfo.170660-0': 'IPP位置',
  'components.IppInfo.170660-1': '曝光时间(μs)',
  'components.IppInfo.170660-2': '帧率(fps)',
  'components.IppInfo.170660-3': '最近上线(时刻)',
  'components.IppInfo.170660-4': '累计在线(小时)',
  'components.IppInfo.170660-6': '机械刷',
  'components.IppInfo.170660-7': '清洁时间间隔(分钟)',
  'components.IppInfo.170660-8': '最近清洁时刻',
  'components.IppInfo.170660-9': '每次清洁刮刷(次)',
  'components.IppInfo.170660-10': '累计清洁(次)',
  'components.IppInfo.170660-11': '测量体积',
  'components.IppInfo.170660-12': '近5分钟采样水体积(mL)',
  'components.IppInfo.170660-13': '累计采样水体积(L)',
  'components.IppInfo.170660-14': '数据详情',
  'components.IppInfo.170660-15': '今日采集(张)',
  'components.IppInfo.170660-16': '累计采集(万张)',
  'components.IppInfo.170660-17': '最后更新',
  info_total_size: '累计大小',
  'components.IppInfo.170660-18': '经度 {0}, 纬度 {1}',
  'components.IppInfo.170660-19': 'IPP位置：',
  'user.index.685648-0': '账号',
  'user.index.685648-1': '邮箱',
  'user.index.685648-2': '手机号',
  'user.index.685648-3': '搜索',
  'user.index.685648-4': '添加',
  'user.index.685648-5': '团队管理',
  'user.index.685648-6': '用户',
  'user.index.685648-7': '手机',
  'user.index.685648-8': '角色',
  'user.index.685648-9': '超级管理员',
  'user.index.685648-10': '管理员',
  'user.index.685648-11': '普通用户',
  'user.index.685648-12': '编辑',
  'user.index.685648-13': '删除',
  'user.index.685648-14': '一个单位只允许1个管理员，3个普通用户',
  'user.index.685648-15': '确认是否删除？',
  'user.index.685648-16': '警告',
  'user.index.685648-17': '确认',
  'user.index.685648-18': '取消',
  'user.index.685648-19': '删除失败',
  'user.index.685648-20': '删除成功',
  'user.edit.990448-0': '返回',
  'user.edit.990448-1': '保存',
  'user.edit.990448-2': '账号',
  'user.edit.990448-3': '用户',
  'user.edit.990448-4': '密码',
  'user.edit.990448-5': '手机',
  'user.edit.990448-6': '邮箱',
  'user.edit.990448-7': '团队',
  'user.edit.990448-8': '请选择团队',
  'user.edit.990448-9': '新增团队',
  'user.edit.990448-10': '超级管理员数量:',
  'user.edit.990448-11': '管理员数量:',
  'user.edit.990448-12': '普通用户数量:',
  'user.edit.990448-13': '角色',
  'user.edit.990448-14': '请选择角色',
  'user.edit.990448-15': '创建团队',
  'user.edit.990448-16': '名称',
  'user.edit.990448-17': '取消',
  'user.edit.990448-18': '确定',
  'user.edit.990448-19': '请输入账号',
  'user.edit.990448-20': '请输入用户',
  'user.edit.990448-21': '请输入密码',
  'user.edit.990448-22': '长度至少 6 个字符',
  'user.edit.990448-23': '请输入手机号',
  'user.edit.990448-24': '请输入邮箱',
  'user.edit.990448-25': '请输入团队名称',
  'user.edit.990448-26': '操作成功!',
  'user.edit.990448-27': '创建团队成功!',
  'system.index.241182-0': '团队管理',
  'system.index.241182-1': '多语言翻译',
  'system.index.241182-2': '保存',
  'system.index.241182-3': '更新',
  'system.index.241182-4': '上传',
  'system.index.241182-5': '请选择仪器',
  'system.index.241182-6': '接口错误',
  'system.index.241182-7': '保存成功!',
  'components.DialogSelectCategory.222105-0': '请输入关键词搜索类别',
  'components.DialogSelectCategory.222105-1': '查询',
  'components.DialogSelectCategory.222105-2': '新建分类',
  'components.DialogSelectCategory.222105-3': '选择类别',
  'components.DialogSelectCategory.222105-4': '· 移入操作',
  'components.DialogSelectCategory.222105-5': '· 复制操作',
  'components.DialogSelectCategory.222105-6': '接口错误',
  'components.DialogSelectCategory.222105-7': '请输入类别名称',
  'components.DialogSelectCategory.222105-8': '新建 {0} 类别',
  'components.DialogSelectCategory.222105-9': '确定',
  'components.DialogSelectCategory.222105-10': '取消',
  'components.DialogSelectCategory.222105-11': '请填写分类名称',
  'components.DialogSelectCategory.222105-12': '操作失败',
  'components.DialogSelectCategory.222105-14': '【{0}】下 {1} 分类新建成功',
  'components.DialogSelectCategory.222105-15':
    '确定是否把 <span style="color: red;font-weight: 700;">{0}</span> 张图片 \n          <span style="color: red;font-weight: 700;">{1}</span> 到 \n          <span style="color: red;font-weight: 700;"> {2}</span>?',
  'components.DialogSelectCategory.222105-16': '操作提示',
  'components.DialogSelectCategory.222105-17': '操作成功',
  'ipp.index.402666-0': '在线状态',
  'ipp.index.402666-1': '位置',
  'ipp.index.402666-2': '搜索',
  'ipp.index.402666-3': '添加IPP',
  'ipp.index.402666-4': '全部站位',
  'ipp.index.402666-5': '站位',
  'ipp.index.402666-6': '站位ID',
  'ipp.index.402666-7': '仪器SN',
  'ipp.index.402666-8': '机械刷状态',
  'ipp.index.402666-9': '配置',
  'ipp.index.402666-10': '查看',
  'ipp.index.402666-11': '删除',
  'ipp.index.402666-12': '接口错误',
  'ipp.index.402666-13': '您确定这个操作吗？',
  'ipp.index.402666-13-1': '阈值过低，谨慎操作',
  'ipp.index.402666-14': '警告',
  'ipp.index.402666-15': '确定',
  'ipp.index.402666-16': '取消',
  'ipp.index.402666-17': '团队',
  'components.DialogSelectUserCategory.619244-0': '请输入关键词搜索类别',
  'components.DialogSelectUserCategory.619244-1': '查询',
  'components.DialogSelectUserCategory.619244-2': '新建分类',
  'components.DialogSelectUserCategory.619244-3': '加入',
  'components.DialogSelectUserCategory.619244-4': '张示例图片',
  'components.DialogSelectUserCategory.619244-5': '无效图像',
  'components.DialogSelectUserCategory.619244-6': '相似度',
  'components.DialogSelectUserCategory.619244-7': '待鉴定图像',
  'components.DialogSelectUserCategory.619244-8': '总数',
  'components.DialogSelectUserCategory.619244-9': '对比',
  'components.DialogSelectUserCategory.619244-10': '选择参考图像',
  'components.DialogSelectUserCategory.619244-11': '选择类别',
  'components.DialogSelectUserCategory.619244-12': '接口错误',
  'components.DialogSelectUserCategory.619244-13': '请输入类别名称（三位数字 + 中文/字母/数字/-/_）',
  'components.DialogSelectUserCategory.619244-14': '新建 {0} 类别',
  'components.DialogSelectUserCategory.619244-15': '确定',
  'components.DialogSelectUserCategory.619244-16': '取消',
  'components.DialogSelectUserCategory.619244-17': '命名不符合规范',
  'components.DialogSelectUserCategory.619244-18': '请填写分类名称',
  'components.DialogSelectUserCategory.619244-19': '操作失败',
  'components.DialogSelectUserCategory.619244-21': '【{0}】下 {1} 分类新建成功',
  'components.DialogSelectUserCategory.619244-22': '人工识别下面不存在<span style="color: red;font-weight: 700;">{0}</span>分类，请确认是否新建分类?',
  'components.DialogSelectUserCategory.619244-23': '操作提示',
  'components.DialogSelectUserCategory.619244-24':
    '确定是否把 <span style="color: red;font-weight: 700;">{0}</span> 张图片\n          <span style="color: red;font-weight: 700;">{1}</span> 到\n          <span style="color: red;font-weight: 700;"> {2}</span>?',
  'ipp.edit.032646-0': '返回',
  'ipp.edit.032646-1': '保存',
  'ipp.edit.032646-2': '网络配置',
  'ipp.edit.032646-3': '仪器信息',
  'ipp.edit.032646-4': '站位ID',
  'ipp.edit.032646-5': '如：21005， 必填',
  'ipp.edit.032646-6': '站位',
  'ipp.edit.032646-7': '经度(°)',
  'ipp.edit.032646-8': '纬度(°)',
  'ipp.edit.032646-9': '团队',
  'ipp.edit.032646-10': '仪器序列号',
  'ipp.edit.032646-11': '在线状态',
  'ipp.edit.032646-12': '累计在线(小时)',
  'ipp.edit.032646-13': '小时',
  'ipp.edit.032646-14': '最近上线(时刻)',
  'ipp.edit.032646-15': '时刻',
  'ipp.edit.032646-16': '舱体温度(℃)',
  'ipp.edit.032646-17': '舱体湿度(%)',
  'ipp.edit.032646-18': '近5分钟采样水体积(mL)',
  'ipp.edit.032646-19': '累计采样水体积(L)',
  'ipp.edit.032646-20': '内存状态(Mb)',
  'ipp.edit.032646-21': '存储状态(Gb)',
  'ipp.edit.032646-22': 'CPU温度(℃)',
  'ipp.edit.032646-23': 'GPU温度(℃)',
  'ipp.edit.032646-24': '数字相机',
  'ipp.edit.032646-25': '曝光时间(μs)',
  'ipp.edit.032646-26': '默认经验值： 80，一般推荐值为80-120',
  'ipp.edit.032646-27': '帧率(fps)',
  'ipp.edit.032646-28': '默认经验值： 3.0，上限为29，推荐值1-7',
  'ipp.edit.032646-29': '增益',
  'ipp.edit.032646-30': '预处理设置',
  'ipp.edit.032646-31': '聚焦评价阈值',
  'ipp.edit.032646-32': '默认经验值： 700或800',
  'ipp.edit.032646-33': '粒径筛选阈值(px)',
  'ipp.edit.032646-34': '默认经验值： 2000-3000。当前阈值为筛选下限。',
  'ipp.edit.032646-35': '二值化阈值',
  'ipp.edit.032646-36': '默认经验值：3或 5',
  'ipp.edit.032646-37': '背景图采样数量(张)',
  'ipp.edit.032646-38': '张',
  'ipp.edit.032646-39': '默认经验值： 50。要求不低于50',
  'ipp.edit.032646-40': '背景图采样间隔(秒)',
  'ipp.edit.032646-41': '秒',
  'ipp.edit.032646-42': '默认经验值： 720',
  'ipp.edit.032646-43': '机械刷',
  'ipp.edit.032646-44': '机械刷状态',
  'ipp.edit.032646-45': '清洁时间间隔(分钟)',
  'ipp.edit.032646-46': '分钟',
  'ipp.edit.032646-47': '推荐时间间隔为30或60分钟',
  'ipp.edit.032646-48': '每次清洁刮刷次数',
  'ipp.edit.032646-49': '推荐清洁每次刮刷2次',
  'ipp.edit.032646-50': '累计清洁次数',
  'ipp.edit.032646-51': '所属团队不能为空!',
  'ipp.edit.032646-52': '确定操作吗?',
  'ipp.edit.032646-53': '提示',
  'ipp.edit.032646-54': '确定',
  'ipp.edit.032646-55': '取消',
  'ipp.edit.032646-56': '保存成功!',
  'ipp.edit.032646-57': '深紫外灯',
  'ipp.edit.032646-58': '成像口紫光频率',
  'ipp.edit.032646-59': '成像口紫光占空比',
  'ipp.edit.032646-60': '照明口紫光频率',
  'ipp.edit.032646-61': '照明口紫光占空比',
  'ipp.edit.032646-62': '深紫外模块电压',
  'ipp.edit.032646-63': '深紫外模块电流',
  'ipp.edit.032646-64': '低功耗板',
  'ipp.edit.032646-65': '低功耗板电流',
  'ipp.edit.032646-66': '低功耗板电压',
  'ipp.edit.032646-67': '低功耗板温度',
  'ipp.edit.032646-68': '载板电流',
  'ipp.edit.032646-69': '载板电压',
  'components.DialogTip.249959-0': '操作提示',
  'components.DialogTip.249959-1': '确定是否把 {0} 添加到回收站?',
  'components.DialogTip.249959-2': '确定是否把 {0} 移入人工识别?',
  'components.DialogTip.249959-3': '确定是否把 {0} 移入临时分类 {1}?',
  'components.DialogTip.249959-4': '确定把 {0} 复制到 {1}?',
  'components.DialogTip.249959-5': '注意：',
  'components.DialogTip.249959-6': '取消',
  'components.DialogTip.249959-7': '确定',
  'components.DialogTip.249959-8': '接口不支持',
  'ipp-image-detail.index.728695-0': 'ROI测量信息',
  'ipp-image-detail.index.728695-1': '类别',
  'ipp-image-detail.index.728695-2': '类别：',
  'ipp-image-detail.index.728695-3': 'ROI参数说明',
  'ipp-image-detail.index.728695-4': '无效图像',
  'ipp-image-detail.index.728695-5': '下载图片',
  'ipp-image-detail.index.728695-6': '点击测量目标大小',
  'ipp-image-detail.index.728695-7': '测量',
  'ipp-image-detail.index.728695-8': '可多次点击不断增强',
  'ipp-image-detail.index.728695-9': '增强',
  'ipp-image-detail.index.728695-10': '点击取消增强效果',
  'ipp-image-detail.index.728695-11': '重置',
  'ipp-image-detail.index.728695-12': '采图时刻 :',
  'ipp-image-detail.index.728695-13': '点击图片关闭本窗口',
  'ipp-image-detail.index.728695-14': '上一张',
  'ipp-image-detail.index.728695-15': '下一张',
  'ipp-image-detail.index.728695-16': '相似推荐',
  'ipp-image-detail.index.728695-17': '获取图像信息失败',
  'ipp-image-detail.index.728695-18': '无效照片',
  'ipp-image-detail.index.728695-19': '接口错误',
  'ipp-image-detail.index.728695-20': '选择 人工识别 类别',
  'ipp-image-detail.index.728695-21': '操作成功',
  'ipp-image-detail.index.728695-22': '不支持操作',
  'ipp-image-detail.index.728695-23': '选择 集萃墙 类别',
  'ipp-image-detail.index.728695-24': '移入回收站',
  'ipp-image-detail.index.728695-25': '移除',
  'ipp-image-detail.index.728695-26': '取消入库',
  'ipp-image-detail.index.728695-27': '取消荟萃',
  'ipp-image-detail.index.728695-28': '删除',
  'ipp-image-detail.index.728695-29': '请确认是否{0}？',
  'ipp-image-detail.index.728695-30': '操作提示',
  'ipp-image-detail.index.728695-31': '操作失败',
  'ipp-image-detail.index.728695-32': '成功',
  'ipp-image-detail.index.728695-33': '点击翻转',
  'ipp-image-detail.index.728695-34': '点击取消翻转',
  'ipp_image.tab1.957792-10-2': '点击隐藏标尺',
  'ipp_image.tab1.957792-10-3': '点击显示标尺',
  'components.RoiInfo.081322-0': '数据详情',
  'components.RoiInfo.081322-1': '最后更新：',

  'components.RoiInfo.081322-2': '当前图像：',
  'components.RoiInfo.081322-3': '今日采集：',
  'components.RoiInfo.081322-4': '张',
  'components.RoiInfo.081322-5': '累计采集：',
  'components.RoiInfo.081322-6': '万张',
  'components.RoiInfo.081322-7': '无效图像',
  'components.ViewRoiWall.247370-0': '秒',
  'components.ViewRoiWall.247370-1': '查看视频',
  'components.ViewRoiWall.247370-2': '接口错误',
  'components.ViewRoiWall.247370-3': '最新数据',
  'group.index.406888-0': '团队名称',
  'group.index.406888-1': '搜索',
  'group.index.406888-2': '添加',
  'group.index.406888-3': '团队ID',
  'group.index.406888-4': '管理员账号',
  'group.index.406888-5': '管理员用户',
  'group.index.406888-6': '名称修改',
  'group.index.406888-7': '删除',
  'group.index.406888-8': '新建',
  'group.index.406888-9': '更新',
  'group.index.406888-10': '取消',
  'group.index.406888-11': '确定',
  'group.index.406888-12': '您确定这个操作吗?',
  'group.index.406888-13': '警告',
  'group.index.406888-14': '提交成功!',
  'group.index.406888-15': '请检查必填项!',
  'components.images.410755-0': '无效图像',
  'components.images.410755-1': '大小：',
  'components.images.410755-2': '当前无数据采集',
  'components.images.410755-3': '最新数据',
  'components.EChartsBar.526258-0': '舱内',
  'components.EChartsBar.526258-1': '数量',
  'components.EChartsBar.526258-2': '丰度',
  'components.EChartsBar.526258-3': '水体体积',
  'components.EChartsBar.526258-4': '文件大小',
  'components.EChartsBar.526258-5': '温度',
  'components.EChartsBar.526258-6': '湿度',
  'components.EChartsBar.526258-7': '舱内温度',
  'components.EChartsBar.526258-8': '舱内湿度',
  'views.login.585449-0': '请输入账号',
  'views.login.585449-1': '请输入密码',
  'views.login.585449-2': '登录',
  'views.login.585449-3': '配置请求域名',
  'views.login.585449-4': '登录密码至少 6 个字符',
  'views.login.585449-5': '配置成功',
  'EChartsBar.DialogSelectDate.617290-0': '选择日期 / 时间',
  'EChartsBar.DialogSelectDate.617290-1': '点击两次选择起始日期与时间范围',
  'EChartsBar.DialogSelectDate.617290-2': '至',
  'EChartsBar.DialogSelectDate.617290-3': '开始日期 时间',
  'EChartsBar.DialogSelectDate.617290-4': '结束日期 时间',
  'EChartsBar.DialogSelectDate.617290-5': '最近 24 小时',
  'EChartsBar.DialogSelectDate.617290-6': '最近 3 天',
  'EChartsBar.DialogSelectDate.617290-7': '最近 7 天',
  'EChartsBar.DialogSelectDate.617290-8': '最近 15 天',
  'EChartsBar.DialogSelectDate.617290-9': '最近 1 月',
  'EChartsBar.DialogSelectDate.617290-10': '最近 3 月',
  'EChartsBar.DialogSelectDate.617290-11': '最近 6 月',
  'EChartsBar.DialogSelectDate.617290-12': '最近 1 年',
  'views.404.671921-0': '啊哦~ 你所访问的页面不存在',
  'views.404.671921-1': '返回首页',
  'views.404.671921-2': '返回上一页',
  'views.403.724508-0': '啊哦~ 你没有权限访问该页面哦',
  'views.403.724508-1': '返回首页',
  'views.403.724508-2': '返回上一页',
  'EChartsBar.index.759330-0': '数据时段定义',
  'EChartsBar.index.759330-1': '时段选择',
  'EChartsBar.index.759330-2': '数据下载',
  'EChartsBar.index.759330-3': '选中',
  'EChartsBar.index.759330-4': '未选择',
  'EChartsBar.index.759330-5': '接口错误',
  'EChartsBar.index.759330-6': '查询全部数据耗将十分耗时，请确定是否操作？',
  'EChartsBar.index.759330-7': '操作提示',
  'EChartsBar.index.759330-8': '数量',
  'EChartsBar.index.759330-9': '近24小时',
  'EChartsPie.index.886326-0': 'ROI数据分类',
  'EChartsPie.index.886326-1': '所有类别',
  'EChartsPie.index.886326-2': '饼图显示数量最多的6类',
  'EChartsPie.index.886326-3': '接口错误',
  'EChartsPie.index.886326-4': '数量:',
  'EChartsPie.index.886326-5': '分类',
  'layout.LayoutHeader.955383-0': '退出',
  'RoiBrowser.IppFolder.011501-0': '万',
  'RoiBrowser.IppFolder.011501-1': '系统类别，不可删除',
  'RoiBrowser.IppFolder.011501-2': '删除',
  'RoiBrowser.IppImages.077288-0': '无效图像',
  'RoiBrowser.IppImages.077288-1': '日期：',
  'RoiBrowser.IppImages.077288-2': '大小：',
  'RoiBrowser.IppImages.077288-3': '类别：',
  'RoiBrowser.IppImages.077288-4': '示例',
  'RoiBrowser.index.168882-0': 'ROI数据管理',
  'RoiBrowser.index.168882-1': '移入 人工识别',
  'RoiBrowser.index.168882-2': '重命名',
  'RoiBrowser.index.168882-3': '请输入文件名',
  'RoiBrowser.index.168882-4': '+ 新建临时分类',
  'RoiBrowser.index.168882-5': '回收站',
  'RoiBrowser.index.168882-6': '全选',
  'RoiBrowser.index.168882-7': '上传示例图片',
  'RoiBrowser.index.168882-8': '请选择',
  'RoiBrowser.index.168882-9': '请输入',
  'RoiBrowser.index.168882-10': '取消全选',
  'RoiBrowser.index.168882-11': '清空',
  'RoiBrowser.index.168882-12': '请注意当前ROI数量可能会超出荟萃屏所支持的最大ROI显示数量！',
  'RoiBrowser.index.168882-12-1': '注意：站位预览页滚屏显示集萃屏电脑端需要ROI数量大于95，手机端需要ROI数量大于40！',
  'RoiBrowser.index.168882-13': '没有图像的分类默认隐藏，可点击关开显示',
  'RoiBrowser.index.168882-14': '显示空分类',
  'RoiBrowser.index.168882-15': '新建分类',
  'RoiBrowser.index.168882-16': '类别数量：{0}',
  'RoiBrowser.index.168882-17': 'ROI数量：{0}',
  'RoiBrowser.index.168882-18': '人工识别',
  'RoiBrowser.index.168882-19': '机器识别',
  'RoiBrowser.index.168882-20': '接口错误',
  'RoiBrowser.index.168882-21': '人工识别下面无【{0}】分类',
  'RoiBrowser.index.168882-22': '示例图片不支持操作',
  'RoiBrowser.index.168882-23': '未配置权限编码',
  'RoiBrowser.index.168882-24': '图像将被移入回收站，确认删除?',
  'RoiBrowser.index.168882-25': '提示',
  'RoiBrowser.index.168882-26': '选择 集萃墙 类别',
  'RoiBrowser.index.168882-27': '选择 人工识别 类别',
  'RoiBrowser.index.168882-28': '确认是否删除 <span style="{0}">{1}</span> 张ROI图像到回收站?',
  'RoiBrowser.index.168882-29': '确认是否把 <span style="{0}">{1}</span> 张ROI图像<span style="{2}">复制</span>到<span style="{3}">Xcube参考库</span>?',
  'RoiBrowser.index.168882-30': '确认是否把 <span style="{0}">{1}</span> 张ROI图像<span style="{2}">移入</span>到<span style="{3}">Xcube参考库</span>?',
  'RoiBrowser.index.168882-31': '确认是否从 <span style="{0}">Xcube参考库</span> 移除 <span style="{1}">{2}</span> 张ROI图像?',
  'RoiBrowser.index.168882-32': '确认是否把 <span style="{0}">{1}</span> 张ROI图像<span style="{2}">复制</span>到<span style="{3}">团队参考库</span>?',
  'RoiBrowser.index.168882-33': '确认是否把 <span style="{0}">{1}</span> 张ROI图像<span style="{2}">移入</span>到<span style="{3}">团队参考库</span>?',
  'RoiBrowser.index.168882-34': '确认是否从 <span style="{0}">团队参考库</span> 移除 <span style="{1}">{2}</span> 张ROI图像?',
  'RoiBrowser.index.168882-35': '确认是否把 <span style="{0}">{1}</span> 张ROI图像<span style="{2}">复制</span>到<span style="{3}">集萃墙</span>?',
  'RoiBrowser.index.168882-36': '确认是否从 <span style="{0}">集萃墙</span> 移除 <span style="{1}">{2}</span> 张ROI图像?',
  'RoiBrowser.index.168882-37': '确认是否把 <span style="{0}">{1}</span> 张ROI图像<span style="{2}">复制</span>到<span style="{3}">{5}</span>{4}?',
  'RoiBrowser.index.168882-38': '确认是否把 <span style="{0}">{1}</span> 张ROI图像<span style="{2}">移入</span>到<span style="{3}">{5}</span>{4}?',
  'RoiBrowser.index.168882-39': '确认是否还原 <span style="{0}">{1}</span> 张ROI图像?',
  'RoiBrowser.index.168882-40': '确定把<span style="{0}">{1}</span>复制<span style="{2}">Xcube参考库</span>?',
  'RoiBrowser.index.168882-41': '复制分类和分类里面的图片',
  'RoiBrowser.index.168882-42': '确定把<span style="{0}">{1}</span>复制<span style="{2}">集萃墙</span>?',
  'RoiBrowser.index.168882-43': '确定把<span style="{0}">{1}</span>复制<span style="{2}">团队参考库</span>?',
  'RoiBrowser.index.168882-44': '仅复制分类里面的图片',
  'RoiBrowser.index.168882-45': '确定在工具栏创建<span style="{0}">{1}</span>快捷方式?',
  'RoiBrowser.index.168882-46': '确定把<span style="{0}">{1}</span>移入<span style="{2}">人工识别</span>?',
  'RoiBrowser.index.168882-47': '仅移入分类里面的图片',
  'RoiBrowser.index.168882-48': '操作成功',
  'RoiBrowser.index.168882-49': '分类名称不允许为空',
  'RoiBrowser.index.168882-50': '全部图像',
  'layout.LayoutMenu.849809-0': '系统配置',
  'layout.LayoutMenu.849809-1': '监测站位',
  'layout.LayoutMenu.849809-2': '系统总览',
  'layout.LayoutMenu.849809-3': '界面管理',
  'layout.LayoutMenu.849809-4': '团队管理',
  'layout.LayoutMenu.849809-5': '用户管理',
  'layout.LayoutMenu.849809-6': '站位管理',
  'layout.LayoutMenu.849809-7': '用户查看',
  'layout.LayoutMenu.849809-8': '仪器查看',
  'layout.LayoutMenu.849809-9': '关于程序',
  'layout.LayoutMenu.849809-10': '识别管理',
  'components.ViewRoi.525393-0': '无图片资源',
  'ipp-image-detail.config.058100-0-1': '文件名',
  'ipp-image-detail.config.058100-0': '采图时刻',
  'ipp-image-detail.config.058100-1': '类别',
  'components.EChartsPie.243795-0': '数量:',
  'components.EChartsPie.243795-1': '分类',
  'admin.index.960941-0': '退出',
  'admin.index.960941-1': '请上传logo',
  'admin.index.960941-2': '24小时数据',
  'admin.index.960941-3': '近30天数据(舱内温度)',
  'admin.index.960941-4': '目标分类',
  'ipp-view-detail.index.531356-0': '{0} {1}时',
  'ipp-view-detail.index.531356-1': '{0} {1}时',
  'ipp-view-detail.index.531356-2': '{0} {1}时',
  'ipp-view-detail.index.531356-3': '{0} {1}时',
  'ipp-view-detail.index.531356-4': '近24时',
  'ipp-view-detail.index.531356-5': '全部',
  'ipp-view-detail.index.531356-6':
    '当前选中时段<span style="{0}">{1}</span> ，共有ROI图像<span style="{2}">{3}</span>张，其中机器识别（AI） <span style="{4}">{5}</span>张，人工识别（HI）<span style="{6}">{7}</span>张，未识别（UI）<span style="{8}">{9}</span>张',
  'ipp-view-detail.index.531356-7': '共有ROI图像<span style="{0}">{1}</span>类、<span style="{2}">{3}</span>张',
  'ipp-view-detail.index.531356-8': '共有ROI图像<span style="{0}">{1}</span>张',
  'ipp-view-detail.index.531356-9':
    '当前选中时段<span style="{0}">{1}</span> ，共有人工识别（HI）ROI图像<span style="{2}">{3}</span>类、<span style="{4}">{5}</span>张',
  'ipp-view-detail.index.531356-10': '当前选中时段<span style="{0}">{1}</span> ，共有ROI图像<span style="{2}">{3}</span>张',
  'ipp-view-detail.index.531356-11':
    '当前选中时段<span style="{0}">{1}</span> ，共有机器识别（AI）ROI图像<span style="{2}">{3}</span>类、<span style="{4}">{5}</span>张',
  'ipp-view-detail.config.628021-0': 'Xcube参考库',
  'ipp-view-detail.config.628021-0-1': '站位参考库',
  'ipp-view-detail.config.628021-1': '团队参考库',
  'ipp-view-detail.config.628021-2': '集萃墙',
  'ipp-view-detail.config.628021-3': '全部图像',
  'ipp-view-detail.config.628021-4': '机器识别',
  'ipp-view-detail.config.628021-5': '人工识别',
  'ipp-view-detail.config.628021-6': '时间',
  'ipp-view-detail.config.628021-7': '大小(kb)',
  'ipp-view-detail.config.628021-8': '数量',
  'ipp-view-detail.config.628021-9': '关注',
  'ipp-view-detail.config.628021-10': '名称',
  'ipp-view-detail.config.628021-11': '丰度',
  'ipp-view-detail.config.628021-12': '水体体积',
  'ipp-view-detail.config.628021-13': '文件大小',
  'ipp-view-detail.config.628021-14': '近24小时',
  'ipp-view-detail.config.628021-15': '近3天',
  'ipp-view-detail.config.628021-16': '近7天',
  'ipp-view-detail.config.628021-17': '近15天',
  'ipp-view-detail.config.628021-18': '近1个月',
  'ipp-view-detail.config.628021-19': '近3个月',
  'ipp-view-detail.config.628021-20': '近6个月',
  'ipp-view-detail.config.628021-21': '近1年',
  'ipp-view-detail.config.628021-22': '全部',
  'ipp-view-detail.config.628021-23': '识别',
  'ipp-view-detail.config.628021-24': '像素数(px)',
  'ipp-view.index.588907-0': '近30天数据',
  'RoiBrowser.utils.074098-0': '全选',
  'RoiBrowser.utils.074098-1': '回收站',
  'RoiBrowser.utils.074098-2': '复制到 Xcube参考库',
  'RoiBrowser.utils.074098-3': '移入 Xcube参考库',
  'RoiBrowser.utils.074098-4': '删除图片',
  'RoiBrowser.utils.074098-5': '复制到 团队参考库',
  'RoiBrowser.utils.074098-6': '移入 团队参考库',
  'RoiBrowser.utils.074098-7': '取消入库',
  'RoiBrowser.utils.074098-8': '复制到 集萃墙',
  'RoiBrowser.utils.074098-9': '移入 集萃墙',
  'RoiBrowser.utils.074098-10': '取消荟萃',
  'RoiBrowser.utils.074098-11': '复制到 人工识别',
  'RoiBrowser.utils.074098-12': '重新 人工识别',
  'RoiBrowser.utils.074098-13': '移入 人工识别',
  'RoiBrowser.utils.074098-14': '复制到',
  'RoiBrowser.utils.074098-15': '移入',
  'RoiBrowser.utils.074098-16': '还原',
  'RoiBrowser.utils.074098-17': '删除',
  'RoiBrowser.utils.074098-18': '新建分类',
  'RoiBrowser.utils.074098-19': '用户可见',
  'RoiBrowser.utils.074098-20': '用户不可见',
  'RoiBrowser.utils.074098-21': '分类和图片',
  'RoiBrowser.utils.074098-22': '分类',
  'RoiBrowser.utils.074098-23': '图片',
  'RoiBrowser.utils.074098-24': '重命名',
  'RoiBrowser.utils.074098-25': '移入 临时分类',
  'RoiBrowser.utils.074098-26': '复制到 临时分类',
  'RoiBrowser.utils.074098-27': '删除分类',
  'RoiBrowser.utils.074098-28': '添加关注',
  'RoiBrowser.utils.074098-29': '取消关注',
  'RoiBrowser.utils.074098-30': '重命名',
  'RoiBrowser.utils.074098-31': '移除图片',
  'RoiBrowser.utils.074098-32': '批准',
  'RoiBrowser.utils.074098-33': '拒绝',
  'RoiBrowser.utils.074098-34': '移入 站位参考库',
  'RoiBrowser.utils.074098-35': '复制到 站位参考库',
  'components.DialogReidentificationRoi.530547-0': '重识别',
  'components.DialogReidentificationRoi.530547-1': '时间范围',
  'components.DialogReidentificationRoi.530547-2': '机器类别',
  'components.DialogReidentificationRoi.530547-3': '请选择',
  'components.DialogReidentificationRoi.530547-4': '提交',
  'components.DialogReidentificationRoi.530547-5': '取消',
  'components.DialogReidentificationRoi.530547-6': '请选择日期',
  'components.DialogReidentificationRoi.530547-7': '获取dev_id失败',
  'components.DialogReidentificationRoi.530547-8': '操作成功',
  'views.about.514986-0':
    'IPP Console系统（软著登字第13042359号）是深圳趣方科技有限公司专为浮游生物原位成像监测仪IPP开发的一款基于智慧物联网(AIoT)的仪器控制与监测信息管理平台。通过部署使用IPP Console系统，用户可以设置和查询自己团队的IPP浮游生物原位成像监测仪工作状态，以联网方式实时连续获取部署在多地的IPP原位采集的图像数据，通过在端侧和云端运行图像处理、AI识别、信息统计算法处理这些数据，用户即可获取覆盖更广阔时空尺度的实时连续浮游生物与水下颗粒物原位观测信息。IPP Console还为用户设计了分级管理功能，方便团队对用户和仪器的管理需求。',
  'floatModal.mini': '小窗模式',
  'floatModal.fullscreen': '全屏模式',
  'floatModal.exitFullscreen': '退出全屏',
  'floatModal.alwaysTop': '置顶',
  'floatModal.cancelTop': '取消固定',
  'floatModal.setTop': '固定顶层',
  'floatModal.restoreWindow': '恢复大窗口',
  'floatModal.close': '关闭',
  'floatModal.restore': '点击恢复'
};
